import {
  SHOW_MODAL,
  HIDE_MODAL,
  SHOW_MODAL_TOP,
  HIDE_MODAL_TOP,
} from '../actions';

import {
  SHOW_CONFIRMATION_MODAL,
  HIDE_CONFIRMATION_MODAL,
  SET_UPGRADE_MODAL,
  ADD_FLASH_MESSAGE,
  REMOVE_FLASH_MESSAGE,
  SET_404,
  SET_LOGGED_IN,
  SET_SETTINGS,
  SET_FILE_SIZES,
  SET_USER_FIELDS,
  SET_DOWNLOAD_URL,
  SET_DROPPED_FILES,
  CLEAR_DROPPED_FILES,
  SET_PROGRESS,
  SET_ONLINE_USERS,
  BLOCK_NAVIGATION,
  SET_BACKEND_ACTION,
  SET_LANGUAGE_MESSAGES,
  SET_FEATURES,
  SET_COUPONS,
  SET_SIDEBAR_OPEN,
  SET_SECOND_SIDEBAR_OPEN,
  SET_SIDEBAR_ACTIVE_TAB,
  SET_APP_VERSION,
  SET_APP_UPDATE_AVAILABLE,
  SET_G2_LOADING,
} from '../actions/App';

const initialConfirmationModalParams = {
  title: null,
  text: '',
  confirmText: null,
  cancelText: null,
  onConfirm: () => (Promise.resolve()),
  onCancel: () => (Promise.resolve()),
};

const initialState = {
  settings: {},
  fileSizes: [],
  userFields: [],
  modal: null,
  modalProps: {},
  modalTop: null,
  modalTopProps: {},
  upgradeModal: null,
  confirmationModal: false,
  confirmationModalParams: initialConfirmationModalParams,
  messages: [],
  downloadUrl: null,
  e404: false,
  loggedIn: false,
  droppedFiles: [],
  progress: {
    total: 0,
    done: 0,
  },
  onlineUsers: [],
  isNavigationBlocked: false,
  backendActions: {},
  languageMessages: {},
  features: [],
  coupons: {},
  sidebarOpen: false,
  secondSidebarOpen: true,
  sidebarActiveTab: '1',
  version: null,
  updateAvailable: false,
  g2Loading: false,
};

export const App = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MODAL:
      return Object.assign({}, state, {
        modal: action.modal,
        modalProps: action.modalProps,
      });

    case HIDE_MODAL:
      return Object.assign({}, state, {
        modal: null,
        modalProps: {},
      });

    case SHOW_MODAL_TOP:
      return Object.assign({}, state, {
        modalTop: action.modal,
        modalTopProps: action.modalProps,
      });

    case HIDE_MODAL_TOP:
      return Object.assign({}, state, {
        modalTop: null,
        modalTopProps: {},
      });

    case SHOW_CONFIRMATION_MODAL:
      return Object.assign({}, state, {
        confirmationModal: true,
        confirmationModalParams: Object.assign({}, initialConfirmationModalParams, action.params),
      });

    case HIDE_CONFIRMATION_MODAL:
      return Object.assign({}, state, {
        confirmationModal: false,
      });

    case SET_UPGRADE_MODAL:
      return Object.assign({}, state, {
        upgradeModal: action.modal,
      });

    case ADD_FLASH_MESSAGE: {
      const messageExists = state.messages.find(f => (f.id === action.message.id));
      if (messageExists) {
        return state;
      }

      return Object.assign({}, state, {
        messages: [...state.messages, action.message],
      });
    }

    case REMOVE_FLASH_MESSAGE:
      return Object.assign({}, state, {
        messages: state.messages.filter(f => (action.messageId !== f.id)),
      });

    case SET_404:
      return Object.assign({}, state, {
        e404: action.status,
      });

    case SET_LOGGED_IN:
      return Object.assign({}, state, {
        loggedIn: action.loggedIn,
      });

    case SET_SETTINGS:
      return Object.assign({}, state, {
        settings: Object.assign({}, state.settings, action.settings),
      });

    case SET_FILE_SIZES:
      return Object.assign({}, state, {
        fileSizes: action.fileSizes,
      });

    case SET_USER_FIELDS:
      return Object.assign({}, state, {
        userFields: action.userFields,
      });

    case SET_DOWNLOAD_URL:
      return Object.assign({}, state, {
        downloadUrl: action.downloadUrl,
      });

    case SET_DROPPED_FILES:
      return Object.assign({}, state, {
        droppedFiles: action.files,
      });

    case CLEAR_DROPPED_FILES:
      return Object.assign({}, state, {
        droppedFiles: [],
      });

    case SET_PROGRESS:
      return Object.assign({}, state, {
        progress: Object.assign({}, state.progress, { total: action.total, done: action.done }),
      });

    case SET_ONLINE_USERS:
      return Object.assign({}, state, {
        onlineUsers: Array.isArray(action.users) ? action.users : Object.keys(action.users),
      });

    case BLOCK_NAVIGATION:
      return Object.assign({}, state, {
        isNavigationBlocked: action.block,
      });

    case SET_BACKEND_ACTION:
      return Object.assign({}, state, {
        backendActions: {
          ...state.backendActions,
          [action.action.id]: action.action.data,
        },
      });

    case SET_LANGUAGE_MESSAGES:
      return Object.assign({}, state, {
        languageMessages: action.messages,
      });

    case SET_FEATURES:
      return Object.assign({}, state, {
        features: action.features,
      });

    case SET_COUPONS:
      return Object.assign({}, state, {
        coupons: action.coupons,
      });

    case SET_SIDEBAR_OPEN:
      return Object.assign({}, state, {
        sidebarOpen: action.sidebarOpen,
      });

    case SET_SECOND_SIDEBAR_OPEN:
      return Object.assign({}, state, {
        secondSidebarOpen: action.secondSidebarOpen,
      });

    case SET_SIDEBAR_ACTIVE_TAB:
      return Object.assign({}, state, {
        sidebarActiveTab: action.sidebarActiveTab,
      });

    case SET_APP_VERSION:
      return Object.assign({}, state, {
        version: action.version,
      });

    case SET_APP_UPDATE_AVAILABLE:
      return Object.assign({}, state, {
        updateAvailable: action.updateAvailable,
      });

    case SET_G2_LOADING:
      return Object.assign({}, state, {
        g2Loading: action.loading,
      });

    default:
      return state;
  }
};
